/*
 * @Author: your name
 * @Date: 2022-03-25 10:10:07
 * @LastEditTime: 2022-03-26 16:00:07
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\plugins\vue-lazy.js
 */

import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
    error: require('@/assets/images/sucai/failed.png'), //报错需要的图片
    loading: require('@/assets/images/sucai/loading.gif')// 替换需要的图片
})